import React, { useState } from "react";
import Messages from "./../icons/Messages";
import Refresh from "./../icons/Refresh";
import File from "./../icons/File";
import Pin from "./../icons/Pin";

const Filter = ({ items, filter, totalPages }) => {
  const [appointments, setAppointments] = useState(items);
  const [activeTab, setActiveTab] = useState(1);
  const url = window.location.pathname;
  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json';

  const switchTab = tab => e => {
    e.preventDefault();

    setActiveTab(tab)

    axios.get(url, {
      params: {
        filter: tab == 0 ? 'last_year' : 'all'
      }
    }, { headers: {'Content-Type': 'text/javascript'} })
    .then(function (response) {
      setAppointments([...response.data]);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  return (
    <div className="cabinet-page__section cabinet-page__section_indent-b_normal">
      <div className="cabinet-page__header-actions cabinet-page__header-actions_indent-b_normal">
        <h3 className="cabinet-page__header">Прошлые посещения</h3>
        <div className="buttons-tabs cabinet-page__filter-tabs">
          <div
            className={`buttons-tabs__tab ${activeTab == 0 ? 'buttons-tabs__tab_active': ''}`}
            onClick={switchTab(0)}>
              За весь год
          </div>
          <div
            className={`buttons-tabs__tab ${activeTab == 1 ? 'buttons-tabs__tab_active': ''} `}
            onClick={switchTab(1)}>
              За все время
            </div>
        </div>
      </div>
      { appointments.map((item, index) =>
        <div className="cabinet-appointment cabinet-appointment_indent-b_normal" key={index}>
          <div className="cabinet-appointment__header">
            <div className="pt-icon-plus cabinet-appointment__doctor-photo">
              { item.doctor &&
                <a className="pt-icon-plus__icon" href={item.doctor ? `/doctors/${item.doctor.id}`: `/services/${item.service.id}`}>
                  <img src={item.doctor.image}/>
                </a>
              }
              <a className="pt-icon-plus__block" href={item.doctor ? `/doctors/${item.doctor.id}`: `/services/${item.service.id}`}>
                { item.doctor ? item.doctor.fullname : item.service.title }
              </a>
            </div>
            <div className="cabinet-appointment__header-actions">
              <a className="pt-icon-plus cabinet-appointment__header-action" href="/reviews">
                <div className="pt-icon-plus__icon pt-icon-plus__icon_indent-r_normal">
                  <Messages />
                </div>
                <div className="pt-icon-plus__block">Оставить отзыв</div>
              </a>
              <a className="pt-icon-plus cabinet-appointment__header-action" href={item.doctor ? item.doctor.link : item.service.link}>
                <div className="pt-icon-plus__icon pt-icon-plus__icon_indent-r_normal">
                  <Refresh />
                </div>
                <div className="pt-icon-plus__block">Записаться еще раз</div>
              </a>
              { item.results &&
                <div className="pt-icon-plus cabinet-appointment__header-action">
                  <div className="pt-icon-plus__icon pt-icon-plus__icon_indent-r_normal">
                    <File />
                  </div>
                  <div className="pt-icon-plus__block">Результаты</div>
                </div>
              }
            </div>
          </div>
          <div className="cabinet-appointment__content">
            <div className="cabinet-appointment__cell">
              <div className="cabinet-appointment__cell-header">{item.primary && 'Первичный прием'}</div>
              <div className="cabinet-appointment__cell-price">
                {item.cost}
                <span>₽</span>
              </div>
              <div className="cabinet-appointment__cell-paid">{item.payed_with}</div>
            </div>
            <div className="cabinet-appointment__cell">
              <div className="cabinet-appointment__cell-header">Дата и время</div>
              <div className="cabinet-appointment__cell-label">{`${item.scheduled_day}, ${item.scheduled_time}`}</div>
            </div>
            <div className="cabinet-appointment__cell">
              <div className="cabinet-appointment__cell-header">Клиника</div>
              <div className="cabinet-appointment__cell-label">{item.address}</div>
              <a className="map-link cabinet-appointment__cell-map" href='#'>
                <Pin />
                Показать на карте
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Filter;
